package com.wintermar.inspection.feature.presentation.inspection.complete.widget.confirm_approval

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CheckboxDefaults
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.component.TextBodyXLarge
import com.wintermar.inspection.core.ui.component.button.Button
import com.wintermar.inspection.core.ui.component.button.variant.ButtonVariant
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.check
import inspection.composeapp.generated.resources.confirm_approval
import inspection.composeapp.generated.resources.confirm_qhse_approval
import inspection.composeapp.generated.resources.confirm_qhse_approved
import inspection.composeapp.generated.resources.ic_check_circle_outline
import inspection.composeapp.generated.resources.inspection_cannot_edit
import inspection.composeapp.generated.resources.mark_as_officially_approved
import inspection.composeapp.generated.resources.you_confirm_audit_reviewed
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@Composable
fun ConfirmApproval(
    dimension: AppDimension = LocalAppTheme.current.dimension,
    color: ThemeColor = LocalAppTheme.current.color,
    onConfirm: () -> Unit
) {
    var isChecked by remember { mutableStateOf(false) }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = dimension.spacing.space4),
        verticalArrangement = Arrangement.spacedBy(
            space = dimension.spacing.space4,
        )
    ) {
        Row(
            modifier = Modifier.align(Alignment.CenterHorizontally)
        ) {
            Icon(
                painter = painterResource(
                    Res.drawable.ic_check_circle_outline
                ),
                tint = color.icon.brand,
                modifier = Modifier.size(dimension.size.icon.l),
                contentDescription = stringResource(Res.string.check)
            )
        }

        TextBodyXLarge(
            text = stringResource(Res.string.confirm_qhse_approval),
            bold = true,
            textAlign = TextAlign.Center,
            modifier = Modifier.fillMaxWidth()
        )

        TextBodySmall(
            text = stringResource(Res.string.you_confirm_audit_reviewed),
            textAlign = TextAlign.Center,
            modifier = Modifier.fillMaxWidth()
        )

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(dimension.radius.lg))
                .background(color.surface.brand.primarySubtle.default)
                .padding(dimension.spacing.space4),
            verticalArrangement = Arrangement.spacedBy(
                space = dimension.spacing.space3,
            )
        ) {
            Item(label = stringResource(Res.string.inspection_cannot_edit))
            Item(label = stringResource(Res.string.mark_as_officially_approved))
        }

        Column(
            modifier = Modifier.padding(vertical = dimension.spacing.space2)
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clickable(
                        enabled = true,
                        indication = null,
                        interactionSource = remember { MutableInteractionSource() },
                        onClick = {
                            isChecked = !isChecked
                        }
                    ),
                horizontalArrangement = Arrangement.spacedBy(
                    space = dimension.spacing.space2,
                ),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Box(
                    modifier = Modifier
                        .size(dimension.size.size5)
                        .clip(RoundedCornerShape(dimension.radius.sm))
                        .border(
                            width = 1.dp,
                            color = if (isChecked) color.border.brand.primary else color.border.default,
                            shape = RoundedCornerShape(dimension.radius.sm)
                        ),
                    contentAlignment = Alignment.Center
                ) {
                    Checkbox(
                        checked = isChecked,
                        onCheckedChange = { isChecked = it },
                        colors = CheckboxDefaults.colors(
                            checkedColor = color.surface.brand.primary.default,
                            uncheckedColor = Color.Transparent,
                            checkmarkColor = Color.White,
                            disabledCheckedColor = color.surface.brand.primary.default.copy(alpha = 0.5f),
                            disabledUncheckedColor = Color.Transparent
                        ),
                        modifier = Modifier.size(dimension.size.size5)
                    )
                }

                TextBodySmall(
                    text = stringResource(Res.string.confirm_qhse_approved)
                )
            }
        }

        Button(
            buttonVariant = ButtonVariant.LargePrimary,
            disabled = !isChecked,
            text = stringResource(Res.string.confirm_approval),
            onClick = onConfirm,
            modifier = Modifier.fillMaxWidth()
        )
        Spacer(modifier = Modifier.height(dimension.spacing.space2))
    }
}

@Composable
private fun Item(
    label: String,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    color: ThemeColor = LocalAppTheme.current.color
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(
            space = dimension.spacing.space2,
        ),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column(
            modifier = Modifier
                .size(dimension.spacing.space2)
                .clip(RoundedCornerShape(dimension.radius.full))
                .background(color.surface.brand.primary.default),
        ) {
            // no-op
        }

        TextBodySmall(text = label)
    }
}
